import React from 'react';
import _isFunction from 'lodash/isFunction';
import { FORM_FIELD_TYPES_COMPONENT_MAP } from './DynamicFormField.constants';
import { FormFieldPropType } from '../../../../../types/FormField.types';
function DynamicFormField(_ref) {
  var field = _ref.field,
    value = _ref.value;
  function getFormFieldComponent() {
    var widgetType = field.widgetType;
    var typeToComponent = FORM_FIELD_TYPES_COMPONENT_MAP[widgetType];
    if (_isFunction(typeToComponent)) {
      return typeToComponent({
        field: field,
        value: value
      });
    }
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, getFormFieldComponent());
}
export default DynamicFormField;